import { fonts } from "../../../styles/theme";
import type { LinhaDeBusca } from "../dados/buscas";
import { Linha, Meta, Posicao, cores } from "../styles";

const ordinal = (posicao: number) => `${posicao}º`;

/** Uma busca acompanhada: posição, onde foi medida e quando — ou o motivo de não ter posição. */
export const LinhaDeBuscaItem = ({ linha }: { linha: LinhaDeBusca }) => {
  const medida = linha.posicao >= 1;
  return (
    <Linha>
      <Posicao $topo={medida && linha.posicao <= 3}>{medida ? ordinal(linha.posicao) : "—"}</Posicao>
      <div className="texto">
        <span className="nome">{linha.titulo}</span>
        <Meta>
          {medida ? (
            <>
              {`${linha.onde}${linha.medidaEm ? ` · medida em ${linha.medidaEm}` : ""}`}
              {linha.posicao > 3 && " · fora do Top 3"}
              {linha.antiga && <span style={{ color: cores.amber, fontFamily: fonts.gilroySemiBold }}> · medição antiga</span>}
            </>
          ) : linha.foraDaLista ? (
            <>
              {`${linha.onde} · medida em ${linha.medidaEm} · `}
              <span style={{ color: cores.ink3, fontFamily: fonts.gilroySemiBold }}>fora da lista medida</span>
              {linha.antiga && <span style={{ color: cores.amber, fontFamily: fonts.gilroySemiBold }}> · medição antiga</span>}
            </>
          ) : (
            "ainda sem posição medida"
          )}
        </Meta>
      </div>
      {linha.link && (medida || linha.foraDaLista) && (
        <a href={linha.link} target="_blank" rel="noreferrer" style={{ fontSize: 13, flexShrink: 0 }}>
          ver
        </a>
      )}
    </Linha>
  );
};
